import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useUser } from '@/hooks/useUser';

export const ErrorAndIncidenceDescription = ({
  errorDetected,
  errorDescription,
  isDocumentationWithIncidence,
  documentationDescription,
}: {
  errorDetected?: boolean;
  errorDescription?: string | null;
  isDocumentationWithIncidence?: boolean;
  documentationDescription?: string | null;
}) => {
  const { userEntity } = useUser();

  const showError = errorDetected && !userEntity?.isRoleMerchantChannelOrAgent();

  if (showError && isDocumentationWithIncidence) {
    return (
      <div className="overflow-text-ellipsis">
        <Font variant={'caption'}>
          (
          <Text tId={errorDescription || ''} /> <Text tId={'AND'} /> <Text tId={documentationDescription || ''} />)
        </Font>
      </div>
    );
  }
  if (showError) {
    return (
      <div className="overflow-text-ellipsis">
        <Font variant={'caption'}>
          (<Text tId={errorDescription || ''} />)
        </Font>
      </div>
    );
  }
  if (isDocumentationWithIncidence) {
    return (
      <div className="overflow-text-ellipsis">
        <Font variant={'caption'}>
          (<Text tId={documentationDescription || ''} />)
        </Font>
      </div>
    );
  }
  return <></>;
};
